import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Table, Space } from 'antd';
import { getOrderList } from '@/services/customerServices';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less';

export default function OrderInfo ({ editId = '', type = 'track' })  {

  const [orderData, setOrderData] = useState([]);
  const navigate = useNavigate()
  useEffect(() => {
    fetchOrderList(editId);
  }, [editId]);

  // 订单列表
  const fetchOrderList = async (editId: string) => {
    try {
      const param = type === 'track' ? { trackId: editId } : { customerId: editId };
      const res: any = await getOrderList(param);
      if (res) {
        setOrderData(res);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleJumpDetail = (record: any) => {
    if (record.dealMode === 'DIRECT') {
      // 直接付款详情
      navigate(`/order/list/details/direct-index/${record.id}`)
    } else {
      // 签约付款详情
      navigate(`/order/list/details/${record.id}`)
    }
  }

  const orderColumns = [
    {
      title: '订单ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '订单金额（元）',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      key: 'createdByName',
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      render: (value) => (
        <span>{ value ? dayjs(value).format('YYYY-MM-DD HH:mm') : ''}</span>
      )
    },
    {
      title: '订单状态',
      key: 'statusDisplay',
      dataIndex: 'statusDisplay',
    },
    {
      title: '操作',
      key: '操作',
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => handleJumpDetail(record)}>详情</a>
        </Space>
      ),
    },
  ];

  return (
    <div className={styles.orderBasicInfoBox}>
      <Table columns={orderColumns} dataSource={orderData} pagination={{pageSize: 3}} />
    </div>
  )
}